/**
 *
 * Converts birthdate to age
 */

export default function ageFromBirthdate (birthdate) {
  return Math.floor((new Date() - birthdate) / 1000 / 60 / 60 / 24 / 365.25)
}



// WEBPACK FOOTER //
// ./src/shared/units/metrics/age.js